module.exports = "/images/tool-checkbox.svg?ebc79fc410e14e86295a502bf7f9c61e";